export default [
  {
    title: 'Log Out',
    icon: 'LogOutIcon',
    // icon: 'book',
    route: 'logout',
  },
]
